import { Grid } from '@material-ui/core';
import React, { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'src/common/components/base-button';
import { InputField } from 'src/common/interfaces/InputField';
import Keypad from 'src/keypad/components/keypad';
import { RifmOptions } from 'src/keypad/keypad-operation';
import FormInputView from 'src/tendering/components/process-tender/form-input-view';
import { styles } from './styles';

export interface VatScreenProps {
  vatAmount: string;
  vatScreen: boolean;
  leftHanded: boolean;
  setVatAmount: React.Dispatch<SetStateAction<string>>;
  setVatScreen: React.Dispatch<SetStateAction<boolean>>;
  getInputCollection: () => InputField[];
  onSubmit: () => void;
}

export const ShowVatScreen = (props: VatScreenProps): JSX.Element | null => {
  const classes = styles();
  const { t } = useTranslation();
  const onInputChange = (event): void => {
    const sanitizedPriceText = (text: string): string =>
      text.replace(/[^.0-9]/g, '').replace(/(\..*)\./g, '.');
    if (event.target.name === 'vat-amount') {
      props.setVatAmount(sanitizedPriceText(event.target.value));
    }
  };
  if (!props.vatScreen) {
    return null;
  }
  return (
    <Grid
      item
      container
      direction='row'
      style={{ paddingBottom: '1vh' }}
      className={classes.vatScreen}
      alignItems='flex-end'
    >
      <Grid
        item
        container
        md={9}
        style={{
          alignItems: 'center',
          justifyContent: 'space-between',
          alignSelf: 'stretch',
        }}
        direction='column'
      >
        <FormInputView
          disabled={false}
          handleInputPayment={() => {}}
          handleInputChange={onInputChange}
          handleOnFocus={() => {}}
          inputCollection={props.getInputCollection()}
          dataTestId='process-tender'
        />

        <Grid item style={{ paddingBottom: '1vh' }}>
          <BaseButton
            color='primary'
            variant='contained'
            className={`${classes.buttonStyles}`}
            centerRipple
            onClick={() => {
              props.setVatAmount('');
              props.setVatScreen(false);
            }}
            data-testid='cancel-vat-button'
          >
            {t('Cancel')}
          </BaseButton>
        </Grid>
      </Grid>
      <Grid item xs={3}>
        <Grid
          item
          style={{ paddingBottom: '1vh', marginLeft: props.leftHanded ? '3vh' : '0vh' }}
          className={`fullHeight`}
        >
          <Keypad
            submitButton={{
              label: 'OK',
              onClick: props.onSubmit,
              testId: 'submit-keypad-button',
            }}
            visible={true}
            topLabelText={t('VAT_Keyboard')}
            noInputField={true}
            keyboardId={'vat-amount'}
            minHeight={'4vh'}
            formatter={RifmOptions.price}
            disableDecimalInput={props.vatAmount === '' ? true : false}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
